import {
  ASSET_MODAL_RIGHT_PANEL_OPEN_TABS,
  type AssetModalRightPanelOpenTab,
} from '~/components/AssetModalV2/assetModalRightPanelTabs';

export const isValidAssetModalRightPanelsTab = (value: string): value is AssetModalRightPanelOpenTab =>
  ASSET_MODAL_RIGHT_PANEL_OPEN_TABS.some((tab) => tab === value);
